let obj = {
  staticDomains: [
    process.env.STATIC_DOMAIN1 || "",
		process.env.STATIC_DOMAIN2 || "",
		process.env.STATIC_DOMAIN3 || ""
  ],
  isProduction: true,
  apiDomains: ["", "", ""],
  apiODomains:{
    API_DOMAIN2: process.env.API_DOMAIN2,
    API_DOMAIN3: process.env.API_DOMAIN3,
    API_DOMAIN4: process.env.API_DOMAIN4
  },
  omniDomain:process.env.LIVE_URL || '',
  serverApiDomain: process.env.API_DOMAIN1,
  environment: process.env.NODE_ENV,
  serverHost: process.env.SERVER_HOST,
  hostKey:process.env.APP_HOST_KEY,
  publicPath: process.env.PUBLIC_PATH || "/",
  staticImageDomains:[
    process.env.IMAGE_DOMAIN1,
		process.env.IMAGE_DOMAIN2,
    process.env.IMAGE_DOMAIN3,
    process.env.IMAGE_DOMAIN4
  ],
  B2B_URL: process.env.B2B_URL,
  NEW_UPLOAD_URL: process.env.NEW_UPLOAD_URL,
  IMAGE_S3_DOMAIN: 'https://s3.ap-south-1.amazonaws.com/3006v1.skenterpriseservices.com/MP_FILESHARE_A/upload/images/product/',
	IMAGE_COMPRESSION:process.env.IMAGE_COMPRESSION,
	PRODUCT_IMAGE_BASE_PATH:process.env.PRODUCT_IMAGE_BASE_PATH,
  PSV_IMAGE_BASE_PATH:process.env.PSV_IMAGE_BASE_PATH,
  fileUploadDirectory : process.env.FILE_UPLOAD_DIRECTORY,
  dashboardReportsPath:"/dashboard/reports/excel-reports",
  serverPort : process.env.PORT || 3025,
  downloadFileDomain: process.env.DASHBOARD_FILE_DOMAIN,
  auditorDomain: process.env.AUDITOR_DOMAIN,
  dcBizDomainUrl: process.env.DC_BIZ_DOMAIN_URL,
  dcJdbizHostUrl: process.env.DC_JDBIZ_HOST_URL,
  jdMobileCheckHostUrl: process.env.JD_MOBILE_CHECK_HOST_URL,
  dcEncSecretKey: process.env.DC_ENC_SECRET_KEY,
  dcEncSecretIvKey: process.env.DC_ENC_SECRET_IV_KEY
};
obj.omniDomain = obj.omniDomain.replace("http","https");
obj.OMNI_AI_URL = process.env.PROD_KEY == "production" ? '192.168.39.26:8000' : '192.168.39.26:8000';
module.exports = obj;